import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import styled from 'styled-components';

import Button from '@/components/Button';
import { Controls, ControlsButton } from '@/components/Controls';
import { PageHeading } from '@/components/Layout/Parts';

import EytvFilesTable from './components/EytvFilesTable';
import EytvUploadModal from './components/EytvUploadModal';
import UploadLinkForm from './components/UploadLinkForm';
import VideosListing from './components/VideosListing';

const HeadingRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const UploadLinkButton = styled(Button)`
  background: transparent;
  margin-left: 16px;
`;

const StyledControls = styled(Controls)`
  display: inline-flex;
  margin-bottom: 12px;
`;

enum Tab {
  UPLOADED = 1,
  IN_PROCESS = 2,
}

const EytvFiles = () => {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showLinkForm, setShowLinkForm] = useState(false);
  const [activeTab, setActiveTab] = useState<Tab>(Tab.UPLOADED);

  const renderCurrentTab = () => {
    switch (activeTab) {
      case Tab.UPLOADED:
        return <EytvFilesTable />;
      case Tab.IN_PROCESS:
        return <VideosListing />;
      default:
        return null;
    }
  };

  return (
    <>
      <HeadingRow>
        <PageHeading>eYTV Files</PageHeading>
        <div>
          <Button onClick={() => setShowUploadModal(true)}>Upload CSV</Button>
          <UploadLinkButton
            color="secondary"
            onClick={() => setShowLinkForm(true)}
          >
            Upload link
          </UploadLinkButton>
        </div>
      </HeadingRow>
      <StyledControls>
        <ControlsButton
          active={activeTab === Tab.UPLOADED}
          onClick={() => setActiveTab(Tab.UPLOADED)}
        >
          Uploaded
        </ControlsButton>
        <ControlsButton
          active={activeTab === Tab.IN_PROCESS}
          onClick={() => setActiveTab(Tab.IN_PROCESS)}
        >
          In Process
        </ControlsButton>
      </StyledControls>
      {renderCurrentTab()}
      <AnimatePresence>
        {showUploadModal && (
          <EytvUploadModal onClose={() => setShowUploadModal(false)} />
        )}
        {showLinkForm && (
          <UploadLinkForm onClose={() => setShowLinkForm(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default EytvFiles;
